import React from 'react';
import { BaasicPageSizeSelectTemplate } from 'themes/components';

function BaasicPageSizeSelect(props) {
	return <BaasicPageSizeSelectTemplate {...props} />;
}

export default BaasicPageSizeSelect;



// WEBPACK FOOTER //
// ./src/core/components/select/BaasicPageSizeSelect.jsx